import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import ProductSection from '../../models/ProductSection';


export interface ProductSectionDetailState extends ApiState {
  productSection?: ProductSection
}

export default requestReducer<ProductSectionDetailState>('PRODUCTSECTION_DETAIL')
